import { useContext, useEffect } from 'react'
import { OnboardingContext } from '../context/onboarding/OnboardingContext'

export default function ActionToggle({ active = false }: { active?: boolean }) {
	const { setActionsOpen } = useContext(OnboardingContext)

	useEffect(() => {
		setActionsOpen(active)
		return () => setActionsOpen(!active)
	}, [])

	return <></>
}
